import { render, staticRenderFns } from "./team.vue?vue&type=template&id=455eb1e0&scoped=true&"
var script = {}
import style0 from "./team.vue?vue&type=style&index=0&id=455eb1e0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455eb1e0",
  null
  
)

export default component.exports